import DefaultPlayer from './defaultPlayer'
import * as Hls from 'hls.js'

/**
 * create player with hls.js
 * extends default html5 player
 * @export
 */
export default class HlsPlayer extends DefaultPlayer {
  constructor(mediaElement, manifestUrl) {
    super(mediaElement, manifestUrl)

    this.playerName_ = "HLS-Player"

    /** @private */
    this.defaultConfig_ = {}
    this.hlsConfig_ = {}

  }

  /** @override */
  initialize() {
    if(Hls.isSupported()) {
      this.player_ = new Hls(this.hlsConfig_)
      this.attach()
      console.log("Hls is supported!")
    } else {
      console.error('Browser not supported!')
    }
  }

  /** @override */
  configure(defaultConfig) {
    const hlsConfig = this.advanceConfig_()
    
    if (defaultConfig['widevine']['licenseUrl']) {
      const {licenseUrl, token} = defaultConfig['widevine']

      // Browser EME 작동 설정 (widevine만 해당)
      hlsConfig['emeEnabled'] = true
      hlsConfig['widevineLicenseUrl'] =  `${licenseUrl}?token=${token}`
      // hlsConfig['drmSystemOptions'] = { 
      //   videoRobustness: 'SW_SECURE_CRYPTO', 
      //   audioRobustness: 'SW_SECURE_CRYPTO' 
      // }
    }

    this.hlsConfig_ = hlsConfig
    this.defaultConfig_ = defaultConfig

    console.log("hlsconfig", hlsConfig)
    this.initialize()
  }

  /** @private */
  advanceConfig_() {
    const config = {
      debug: false,
      // capLevelToPlayerSize: true, // 해상도를 고정하여 적응형 레벨 변동성 제거
      enableWorker: true,
      autoStartLoad: false, // start level 지정을 위해 자동 시작 취소
      // manifestLoadingTimeOut: 5000,
      // testBandwidth: false,
      // lowLatencyMode: false,
      // progressive: true,
      // abrMaxWithRealBitrate: true,
      // liveMaxLatencyDurationCount: Infinity,
      // liveSyncDurationCount: 2,
      // forceKeyFrameOnDiscontinuity: false,
      // maxBufferHole: 1.2
      // minAutoBitrate: 4<<20,
      // abrEwmaDefaultEstimate: 4<<20,
      // backBufferLength: 14400, // 재생 후 버퍼에 저장할 미디어 기간
      // liveMaxLatencyDuration: 12, // 라이브 지연 last fragment - N 에서 시작, count보다 우선
    }

    return config
  }

  /** 
   * @override
   * @returns {!Promise} 
  */
  async load() {
    this.player_.loadSource(this.manifestUrl_)
    window.hls = this.player_
    
    const setHighestLvl = (levels) => (
      // hls.levels 중 최고 bitrate 를 지닌 level의 idx 반환
      levels.map((level, idx) => ({ index: idx, value: level }))
          .sort((a, b) => a.value.bitrate - b.value.bitrate)
          .pop()
    ).idx || 2

    await new Promise((resolve) => {
      // this.player_.on(Hls.Events.LEVEL_LOADED, function(event, data) {
      //   console.log("level loaded data", data)
      // })
      this.player_.on(Hls.Events.MANIFEST_PARSED, function(event, data) {
        console.log("manifest loaded, found ", data)
        // manifest (playlist.m3u8)에 존재하는 가장 큰 대역폭으로 설정 (1080 예상)
        this.player_.loadLevel = setHighestLvl(data.levels) 
        this.player_.startLoad()
        resolve()
      }.bind(this))
    })
  }

  /** @override */
  attach() {
    this.player_.attachMedia(this.mediaElement_)
  }

  /** @override */
  detach() {
    this.player_.detachMedia(this.mediaElement_)
  }

  /** @override */
  isLive() {
    this.player_.levels[this.player_.currentLevel].details.live || false
  }

  /** @private */
  currentBandWidth_() {
    return this.player_.levels[this.player_.currentLevel].bitrate || NaN
  }
  
  /** @override */
  seekRange() {
    if (this.player_.levels[this.player_.currentLevel]) {
      let { fragments } = this.player_.levels[this.player_.currentLevel].details
      return {
        start: fragments[0].start,
        end: fragments[fragments.length - 1].end
      }
    } else {
      return super.seekRange()
    }
  }

  /** @override */
  destroy() {
    super.destroy()
  }
}